import { render, staticRenderFns } from "./GrnEdit.vue?vue&type=template&id=2c07068a"
import script from "./GrnEdit.vue?vue&type=script&lang=js"
export * from "./GrnEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports